export const RetailApplicationModel = {
  id: "",
  retailAppId: null,
  eventId: "",
  traderId: "",
  appId: "",
  onSiteContact: null,
  describesyourstand: null,
  itemstobesold: null,
  trestletable: false,
  trestletablePrice: null,
  bannerrailfortents: null,
  bannerrailfortentsPrice: null,
  additionalpasses: null,
  additionalpassesPrice: null,
  twinsockets13amp: null,
  twinsockets13ampPrice: null,
  amp16: null,
  amp16Price: null,
  amp32: null,
  amp32Price: null,
  adminFee: null,
  applicationFee: null,
  vat: null,
  status: null,
  initialPaymentPer: null,
  payOutDate: null,
  createdOn: null,
  createdBy: null,
  updatedOn: null,
  updatedBy: null,
  isActive: null,
  isDeleted: null,
  charityNumber: null,
  pitchId: null,
  processPercent: null,
  traderPitchId: null,
  objEventApplicationRetailPitchDtlViewModel: [],
};
